import axios from 'axios'

export const getWarehouses = ({ commit }) => {
  commit('setLoading', true);
  axios.get('/api/warehouses/list')
    .then(response => {
      commit('getWarehouse', response.data.data)
    })
    // fail
    .catch(e => {
      console.error('warehouse/getWarehouses:', e);
      commit('getWarehouse', [])
    })
    .finally(() => {
      commit('setLoading', false);
    });
}